import { Component, OnInit, Input } from '@angular/core';
import { EmployeeService } from '../../../../pages/employee/services/employee.service';
import { PortalSettingsService } from '../../../../core/services/portal-settings.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '../../../../core/services/utility.service';
import moment from 'moment';

@Component({
  selector: 'app-process-expense-modal',
  templateUrl: './process-expense-modal.component.html',
  styleUrls: ['./process-expense-modal.component.css']
})
export class ProcessExpenseModalComponent implements OnInit {
  @Input() data: any;
  @Input() prco: any;
  @Input() prGroup: any;
  @Input() type: any;
  portalSettings: any;
  monthFormat: string;
  exAddAPReftoPosting: boolean;
  showAPRef: boolean;
  formData: { [key: string]: any } = {};
  ProcessType: any;
  defaultEarnCode: any;
  approvedCount: number;
  unApprovedCount: number;
  sum: number;
  payPeriodList: any;
  paySeqList: any;
  earnCodeList: any;
  currencySymbol: string;
  submitString: any;
  datePickerOptionsMonth: { dateInputFormat: string; containerClass: string; showTodayButton: boolean; showClearButton: boolean; clearPosition: string; showWeekNumbers: boolean; setViewMode: string };
  vendorList: any;
  alert: { [key: string]: any } = {}

  constructor(private employeeService: EmployeeService, public activeModal: NgbActiveModal, portalSettingsService: PortalSettingsService, private utilityService: UtilityService) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.currencySymbol = this.utilityService.getCurrencySymbol();
    this.alert = null;
  }

  ngOnInit(): void {
    this.datePickerOptionsMonth = { dateInputFormat: "MM/YYYY", containerClass: "theme-blue", showTodayButton: true, showClearButton: true, clearPosition: "left", showWeekNumbers: false, setViewMode: "month" };
    this.exAddAPReftoPosting = this.portalSettings.ExAddAPReftoPosting.ConfigValue == "1"
    this.showAPRef = this.portalSettings.ExAddAPReftoPosting.ConfigValue == "1" && this.portalSettings.ExpensePostingType.ConfigValue.toLowerCase() != "p";
    this.formData.aPRef = null;
    this.ProcessType = this.type != "C" ? this.portalSettings.ExpensePostingType.ConfigValue : this.type;
    this.defaultEarnCode = this.portalSettings.EXCompanyEarnCodeMapping.ConfigValue;
    this.formData.SelectedPayPeriod = null;
    this.formData.SelectedPaySeq = null;
    this.formData.SelectedEarnCode = null;
    this.formData.SelectedVendor = null;
    this.approvedCount = 0;
    this.unApprovedCount = 0;
    this.sum = 0.0;
    this.submitString = "";

    this.data.forEach((val: any, key) => {
      if (val.Selected) { 
        if (val.ReceiptStatusLabel == "Approved") {
          this.approvedCount++;
        } else {
          this.unApprovedCount++;
        }
        this.sum += val.ReceiptAmount;
      }
    })

    this.getPayPeriods();
    this.getEarnCodes();
    if (this.type == "C")
        this.getCreditCardVendors();
  }

  public getPayPeriods() {
    this.employeeService.getPayPeriods(this.prco, this.prGroup).then((response: any) => {
      this.payPeriodList = response;
    })
  }

  public getPaySeq() {
    this.employeeService.getPaySeq(this.formData.SelectedPayPeriod.PRPCKeyID).then((response: any) => {
      this.paySeqList = response;
    })
  }

  private getEarnCodes() {
    this.employeeService.getEarnCodes(this.prco).then((response: any) => {
      this.earnCodeList = response;
      this.earnCodeList.forEach((val: any, key) => {
        if (val.IsDefault)
          this.formData.SelectedEarnCode = val.EarnCode;
        val.DisplayName = val.EarnCode + ' - ' + val.EarnCodeDescription;
      });
      this.earnCodeList.unshift({
        EarnCode: null,
        EarnCodeDescription: "Use Earn Code Specified on Expense Line",
        IsDefault: false,
        DisplayName: "Use Earn Code Specified on Expense Line"

      });
      if (!this.formData.SelectedEarnCode) {
        this.formData.SelectedEarnCode = this.earnCodeList[0].EarnCode;
      }
    })
  }

  private getCreditCardVendors() {
    this.utilityService.openModal();
    this.employeeService.getCreditCardvendors(this.prco).then((response: any)=>{
        this.utilityService.closeModal();
        if (response != null && response.length > 0) {
            this.vendorList = response;
            this.formData.SelectedVendor = this.vendorList[0].KeyID;
        }
    });
}

  public processClicked(method) {
    this.utilityService.openModal();

    var idsToSubmit = [];
    this.data.forEach((val: any, key) => {
      if (val.Selected) {
        if (!idsToSubmit.includes(val.ReceiptID)) {
          idsToSubmit.push(val.ReceiptID);
        }
      }
    })
    this.submitString = idsToSubmit.join(",");

    if (this.formData.selectedMonth != null) {
      if (this.formData.selectedMonth.getDate() > 1) {
        this.formData.selectedMonth = new Date(this.formData.selectedMonth.getFullYear(), this.formData.selectedMonth.getMonth(), 1);
      }
    }
    this.employeeService.processExpense(method, (this.formData.SelectedPayPeriod == null ? null : this.formData.SelectedPayPeriod.PRPCKeyID), this.formData.SelectedPaySeq,
      this.formData.SelectedEarnCode, this.submitString, this.prco, moment(this.formData.selectedMonth).format("YYYY-MM-DD"), this.formData.aPRef, null, this.formData.SelectedVendor).then((response: any) => {
        this.utilityService.closeModal();
        this.activeModal.close(response);
      }).catch((error: any) => {
        this.utilityService.closeModal();
        this.alert = { type: "danger", msg: error?.error?.error ?? "An error has occured."};
      });
  }

  public onOpenCalendar(container) {
    container.monthSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(event.date));
    };
    container.setViewMode('month');
  }

  public cancelClicked() {
    this.activeModal.close();
  }
}
